/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// The main logic for handling message center actions

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  return exports.MessageCenter = class MessageCenter {
    constructor(options) {
      if (options == null) { options = {}; }
      this.attachEventListeners();
    }

    attachEventListeners() {
      return jQuery(document).on('click', '[data-message-item] input[type="button"][data-remote]', function(ev) {
        let old_label;
        const target = $(ev.target);
        const container = target.closest('[data-message-item]');
        const form = container.find('[data-message-item-form]');

        const url = target.data('url');
        const disable_with = target.data('disable-with');

        if (disable_with != null) {
          old_label = target.val();
          target.val(disable_with).prop('disabled', true);
        } else {
          old_label = null;
        }

        // Serialize the form
        const data = form.find(':input').serialize();

        $.post(url, data, function(data) {
          if (old_label != null) {
            return target.val(old_label).prop('disabled', false);
          }
        });

        return ev.preventDefault();
      });
    }
  };
});
